import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { DynamicFormComponent }   from './components/dynamic-form/dynamic-form.component';
import { DynamicFieldComponent }  from './components/dynamic-field/dynamic-field.component';
import { FIELD_REGISTRY }         from './tokens/field-registry.token';

import { TextFieldComponent }     from './components/fields/text-field/text-field.component';
import { SelectFieldComponent }   from './components/fields/select-field/select-field.component';
import { MultiSelectFieldComponent } from './components/fields/multi-select-field/multi-select-field.component';
import { CheckboxFieldComponent } from './components/fields/checkbox-field/checkbox-field.component';
import { TextareaFieldComponent } from './components/fields/textarea-field/textarea-field.component';
import { HeadingFieldComponent }  from './components/fields/heading-field/heading-field.component';
import { ParagraphFieldComponent } from './components/fields/paragraph-field/paragraph-field.component';
import { ImageFieldComponent }    from './components/fields/image-field/image-field.component';
import { RadioFieldComponent }    from './components/fields/radio-field/radio-field.component';
import { DateFieldComponent }     from './components/fields/date-field/date-field.component';
import { FileFieldComponent }     from './components/fields/file-field/file-field.component';

@NgModule({
  imports: [
    HttpClientModule,
    DynamicFormComponent,
    DynamicFieldComponent,
  ],
  exports: [
    DynamicFormComponent,   // ← única exportación pública
  ],
  providers: [
    {
      provide: FIELD_REGISTRY,
      useValue: {
        text:        TextFieldComponent,
        email:       TextFieldComponent,
        password:    TextFieldComponent,
        number:      TextFieldComponent,
        date:        DateFieldComponent,
        file:        FileFieldComponent,
        hidden:      TextFieldComponent,
        custom:      TextFieldComponent,
        textarea:    TextareaFieldComponent,
        select:      SelectFieldComponent,
        multiselect: MultiSelectFieldComponent,
        radio:       RadioFieldComponent,
        checkbox:    CheckboxFieldComponent,
        heading:     HeadingFieldComponent,
        paragraph:   ParagraphFieldComponent,
        image:       ImageFieldComponent,
      }
    }
  ]
})
export class AdminFormsModule {}